import React from "react";

import styled from "styled-components";
import { QuickSortNumberContainer } from "../number/QuickSortNumberContainer";

const StyledNumbersContainer = styled.div`
  /* background: lightblue; */
  display: flex;
`;

interface IQuickSortNumbersContainerProps {
  Numbers: Array<number> | undefined;
  HI: number | undefined;
  LO: number | undefined;
  ICount: number | undefined;
  JCount: number | undefined;
  Pivot: number | undefined;
  PartitionNumber: number | undefined;
  SortedIndices: Array<number> | undefined,
}

export function QuickSortNumbersContainer({
  Numbers, HI, LO, ICount, JCount, Pivot, PartitionNumber, SortedIndices
} : IQuickSortNumbersContainerProps) {
  return (
    <StyledNumbersContainer>
      {Numbers !== undefined && Numbers.length > 0 && (

        <>
          <QuickSortNumberContainer
            HI={HI}
            LO={LO}             
            ICount={ICount}
            JCount={JCount}
            PartitionNumber={PartitionNumber}
            Index={-1}
          />

          {Numbers.map((n, i) => {
            let sorted : boolean = false;

            if (SortedIndices !== undefined)
              sorted = SortedIndices?.indexOf(i) >= 0;

            return (
              <QuickSortNumberContainer key={i} 
                Number={n} 
                HI={HI}
                LO={LO}             
                ICount={ICount}
                JCount={JCount}
                PartitionNumber={PartitionNumber}
                Index={i}
                Sorted={sorted}
              />);
          })}

          <QuickSortNumberContainer 
            HI={HI}
            LO={LO}             
            ICount={ICount}
            JCount={JCount}
            PartitionNumber={PartitionNumber}
            Index={Numbers.length}
          />
        </>
      )}
    </StyledNumbersContainer>
  );
}
